import React, { useState, useEffect } from 'react';
import { BottomNavigation, BottomNavigationAction, Paper, Snackbar, Badge, Box } from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';

// Iconos
import HomeIcon from '@mui/icons-material/Home';
import EventIcon from '@mui/icons-material/Event';
import PersonIcon from '@mui/icons-material/Person';
import SearchIcon from '@mui/icons-material/Search';
import MapIcon from '@mui/icons-material/Map';

const BottomNavigationBar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [value, setValue] = useState(getInitialValue(location.pathname));
  const [userData, setUserData] = useState(null);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');

  useEffect(() => {
    const storedUserData = localStorage.getItem('userData');
    if (storedUserData) {
      setUserData(JSON.parse(storedUserData));
    }
  }, []);

  function getInitialValue(pathname) {
    if (pathname === '/') return 0;
    if (pathname.includes('/invitaciones')) return 1;
    if (pathname.includes('/perfil')) return 2;
    return 0;
  }

  const handleChange = (event, newValue) => {
    if (userData.userID == 0 && (newValue === 1 || newValue === 2)) {
      const page = newValue === 1 ? 'Invitaciones' : 'Perfil';
      setSnackbarMessage(`Debe iniciar sesión para acceder a ${page}`);
      setSnackbarOpen(true);
      return;
    } else {
      setValue(newValue);
      switch (newValue) {
        case 0:
          navigate('/');
          break;
        case 1:
          navigate('/invitaciones');
          break;
        case 2:
          navigate('/perfil');
          break;
        default:
          navigate('/');
      }

    }

  };

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  return (
    <>
      <Box sx={{ pb: `calc(60px + env(safe-area-inset-bottom))` }} />
      <Paper
        sx={{
          backgroundColor: '#ffffff',
          position: 'fixed',
          bottom: 0,
          left: 0,
          right: 0,
          zIndex: 1000,
          borderTop: '1px solid rgba(0, 0, 0, 0.08)',
          paddingBottom: 'env(safe-area-inset-bottom)',
          boxShadow: '0 -1px 8px rgba(0, 0, 0, 0.06)',
          height: 'auto',
          borderRadius: '12px 12px 0 0',
          overflow: 'hidden'
        }}
        elevation={0}
      >
        <BottomNavigation
          value={value}
          onChange={handleChange}
          showLabels
          sx={{
            backgroundColor: '#ffffff',
            height: 60,
            '& .MuiBottomNavigationAction-root': {
              minWidth: 'auto',
              padding: '6px 0',
              color: '#9e9e9e',
              position: 'relative',
              transition: 'all 0.2s',
              '&::after': {
                content: '""',
                position: 'absolute',
                bottom: 0,
                left: '50%',
                width: 0,
                height: 3,
                backgroundColor: '#009688',
                transition: 'all 0.2s',
                borderRadius: '3px 3px 0 0',
                transform: 'translateX(-50%)'
              },
              '&.Mui-selected': {
                color: '#009688',
                '&::after': {
                  width: '50%',
                }
              },
              '&:hover': {
                backgroundColor: 'rgba(0, 150, 136, 0.04)'
              },
              '&:active': {
                backgroundColor: 'rgba(0, 150, 136, 0.08)'
              }
            },
            '& .MuiBottomNavigationAction-label': {
              fontSize: '0.7rem',
              transition: 'font-size 0.2s, opacity 0.2s',
              opacity: 0.7,
              marginTop: '2px',
              '&.Mui-selected': {
                opacity: 1,
                fontSize: '0.75rem',
                fontWeight: 500
              },
            },
            '& .MuiTouchRipple-root': {
              color: 'rgba(0, 150, 136, 0.1)'
            }
          }}
        >
          <BottomNavigationAction
            label="Inicio"
            icon={
              <Box sx={{ 
                display: 'flex', 
                alignItems: 'center', 
                justifyContent: 'center',
                height: 28,
                position: 'relative',
                transition: 'transform 0.2s'
              }}>
                <HomeIcon 
                  sx={{ 
                    fontSize: value === 0 ? 28 : 24, 
                    transition: 'all 0.2s',
                    transform: value === 0 ? 'scale(1.1)' : 'scale(1)'
                  }} 
                />
              </Box>
            }
            sx={{
              '&.Mui-selected': {
                '& .MuiSvgIcon-root': { color: '#009688' },
              },
            }}
          />

          {userData && (
            <BottomNavigationAction
              label="Invitaciones"
              icon={
                <Box sx={{ 
                  display: 'flex', 
                  alignItems: 'center', 
                  justifyContent: 'center',
                  height: 28,
                  position: 'relative',
                  transition: 'transform 0.2s'
                }}>
                  {/* <Badge 
                    color="error" 
                    variant="dot" 
                    invisible={false}
                    sx={{
                      '& .MuiBadge-badge': {
                        top: 2,
                        right: -2,
                        transform: value === 1 ? 'scale(1.2)' : 'scale(1)',
                        transition: 'transform 0.2s'
                      }
                    }}
                  > */}
                    <EventIcon 
                      sx={{ 
                        fontSize: value === 1 ? 28 : 24, 
                        transition: 'all 0.2s',
                        transform: value === 1 ? 'scale(1.1)' : 'scale(1)'
                      }} 
                    />
                  {/* </Badge> */}
                </Box>
              }
              sx={{
                '&.Mui-selected': {
                  '& .MuiSvgIcon-root': { color: '#009688' },
                },
              }}
            />
          )}

          {userData && (
            <BottomNavigationAction
              label="Perfil"
              icon={
                <Box sx={{ 
                  display: 'flex', 
                  alignItems: 'center', 
                  justifyContent: 'center',
                  height: 28,
                  position: 'relative',
                  transition: 'transform 0.2s'
                }}>
                  <PersonIcon 
                    sx={{ 
                      fontSize: value === 2 ? 28 : 24, 
                      transition: 'all 0.2s',
                      transform: value === 2 ? 'scale(1.1)' : 'scale(1)'
                    }} 
                  />
                </Box>
              }
              sx={{
                '&.Mui-selected': {
                  '& .MuiSvgIcon-root': { color: '#009688' },
                },
              }}
            />
          )}
        </BottomNavigation>
      </Paper>
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={3000}
        onClose={handleSnackbarClose}
        message={snackbarMessage}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        sx={{ mb: 9 }}
      />
    </>
  );
};

export default BottomNavigationBar;